import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, ShieldCheckIcon, StarIcon, UsersIcon, ZapIcon } from 'lucide-react';
const TRUST_ITEMS = [{
  icon: UsersIcon,
  label: '+3.500 TERAPEUTAS'
}, {
  icon: ZapIcon,
  label: 'ACCESO INMEDIATO'
}, {
  icon: ShieldCheckIcon,
  label: 'GARANTÍA 7 DÍAS'
}];
const KIT_BENEFITS = ['Manual y guiones de sesión', 'Genograma familiar', '350 preguntas terapéuticas', 'Fichas y seguimiento', 'Tarjetas y dinámicas', 'Acceso inmediato y de por vida'];
const TRUST_FOOTER = ['Compra segura', 'Descarga inmediata', 'Acceso de por vida'];
const IS_PROMOTION_ACTIVE = true;
const THERAPISTS_IMAGE = 'https://cdn.magicpatterns.com/uploads/2JGhmRg6x9QoH58qnk485A/Collage_de_cuatro_retratos_circulares.webp';
export function Hero() {
  const prefersReducedMotion = useReducedMotion();
  const scrollToPurchase = () => {
    document.getElementById('purchase')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className="relative w-full bg-[#fdfbf7] overflow-hidden" data-id="element-174" data-mp="3j9afx9oryk3k">
      {/* Soft warm light, top-center */}
      <div aria-hidden="true" className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 w-[140%] h-[420px] rounded-full bg-[#f3ece0] opacity-60 blur-3xl" data-id="element-175" data-mp="3o59dnnvztegn" />

      <div className="relative z-10 mx-auto w-full max-w-[560px] md:max-w-3xl px-5 pt-5 pb-7 md:pt-8 md:pb-10" data-id="element-176" data-mp="3ebiqqnfilc32">
        {/* Trust bar */}
        <ul className="flex items-center justify-between gap-2 border-b border-[#e6ddcd] pb-4" data-id="element-177" data-mp="3599k48nda2uy">
          {TRUST_ITEMS.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex flex-1 flex-col items-center gap-1.5 text-center" data-id="element-178" data-mp="2qhqurk8mavyx">
              <Icon size={16} strokeWidth={1.75} className="text-[#a8894f]" aria-hidden="true" data-id="element-179" data-mp="2hina4btsy8ib" />
              <span className="text-[9px] md:text-[11px] font-bold uppercase tracking-[0.12em] text-[#4c3a63] leading-tight" data-id="element-180" data-mp="2lml98mj4njbd">
                {label}
              </span>
            </li>)}
        </ul>

        {/* Headline block */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        ease: [0.23, 1, 0.32, 1]
      }} className="pt-7 text-center" data-id="element-181" data-mp="id9u8ert6duc">
          <p className="text-[10px] md:text-xs font-bold uppercase tracking-[0.34em] text-[#a8894f]" data-id="element-182" data-mp="1b0ds7zshhrwm">
            Kit profesional de
          </p>

          <h1 className="mt-3 font-['Playfair_Display',_serif] text-[#3b1076] leading-[0.92]" data-id="element-183" data-mp="112g3zcamjv40">
            <span className="block text-[40px] md:text-[68px] font-black tracking-[-0.02em]" data-id="element-184" data-mp="x14ldqq64a5b">
              CONSTELACIÓN
            </span>
            <span className="block text-[40px] md:text-[68px] font-black tracking-[-0.02em]" data-id="element-185" data-mp="3ltqddexn6zuk">
              FAMILIAR
            </span>
            <span className="mt-3 flex items-center justify-center gap-3" data-id="element-186" data-mp="3htg9q8xboliv">
              <span className="h-px w-8 md:w-14 bg-[#cbb98f]" data-id="element-187" data-mp="1xaw06rmvemay" />
              <span className="text-[15px] md:text-[22px] font-normal uppercase tracking-[0.3em] text-[#6b4fa0]" data-id="element-188" data-mp="21aefn7vxa56e">
                Terapéutica
              </span>
              <span className="h-px w-8 md:w-14 bg-[#cbb98f]" data-id="element-189" data-mp="2686aa9nyc5ea" />
            </span>
          </h1>

          <p className="mx-auto mt-4 w-full max-w-none text-[15px] font-medium leading-relaxed text-[#574a63] md:max-w-[52ch] md:text-[17px]" data-id="element-190" data-mp="2b2k9yo9ncyor">
            Prepará sesiones de Constelaciones Familiares con{' '}
            <strong className="font-extrabold text-[#3b1076]" data-id="element-191" data-mp="2p0h83p3r1d5j">
              más seguridad y estructura
            </strong>
            , utilizando guiones, genogramas, preguntas y{' '}
            <strong className="font-extrabold text-[#3b1076]" data-id="element-192" data-mp="2tx7o6cfk08qy">
              herramientas listas para usar.
            </strong>
          </p>
        </motion.div>

        {/* Product */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-4 -mx-5 md:mx-0" data-id="element-193" data-mp="znn6i9cpu6xv">
          <motion.div animate={prefersReducedMotion ? undefined : {
          y: [0, -10, 0]
        }} transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-194" data-mp="e9jxju49n9rw">
            <img src="https://cdn.magicpatterns.com/uploads/jSVG6V9URxa54G4NYKpbuG/ChatGPT_Image_13_sept_2026,_22_34_22.png" alt="Kit profesional de Constelación Familiar Terapéutica: libro Sistema Profesional junto a las fichas impresas de genograma, sesión, preguntas terapéuticas, mapas de relaciones y guiones" className="w-full h-auto block" data-id="element-195" data-mp="3cs8qc4p3shq1" />
          </motion.div>
        </motion.div>

        {/* Compact social proof using the supplied therapist collage */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.5
      }} transition={{
        duration: 0.35,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-3 flex items-center justify-center gap-3" data-id="element-196" data-mp="19h2m46fhcxz4">
          <div className="flex -space-x-2" aria-label="Retratos de terapeutas" data-id="element-197" data-mp="14ju54962izzg">
            {[0, 1, 2, 3].map(portrait => <span key={portrait} className="h-9 w-9 overflow-hidden rounded-full border-2 border-[#fdfbf7] bg-[#ece4d7] shadow-sm" data-id="element-198" data-mp="1x884as8w82cl">
                <img src={THERAPISTS_IMAGE} alt="" className="h-full w-[400%] max-w-none object-cover" style={{
              transform: `translateX(-${portrait * 25}%)`
            }} data-id="element-199" data-mp="1jajk7mmngz8l" />
              </span>)}
          </div>
          <div className="text-left" data-id="element-200" data-mp="bsskhsjlwc8j">
            <span className="flex items-center gap-0.5" aria-label="Cinco estrellas" data-id="element-201" data-mp="2ei3o81a9e1dh">
              {[...Array(5)].map((_, i) => <StarIcon key={i} size={13} className="text-[#d8a53a]" fill="currentColor" strokeWidth={0} data-id="element-202" data-mp="29jscfl0elgsm" data-mpi={i} />)}
            </span>
            <p className="mt-0.5 text-[12px] font-semibold text-[#4c3a63]" data-id="element-203" data-mp="1vr2r7isp8fwk">
              <strong className="font-extrabold" data-id="element-204" data-mp="1vozru85npaf6">4.9/5</strong>
              <span className="mx-1 text-[#c3b49d]" data-id="element-205" data-mp="1qqybvw3j1r7x">·</span>
              valoración de terapeutas
            </p>
          </div>
        </motion.div>

        {/* Practical resources */}
        <motion.ul initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.05
          }
        }
      }} className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2 rounded-2xl border border-[#e8decf] bg-white/70 p-3 text-left" style={{
        paddingTop: "0px",
        paddingBottom: "0px",
        gap: "0px"
      }} data-id="element-206" data-mp="1gulikzbw9fdp">
          {KIT_BENEFITS.map(benefit => <motion.li key={benefit} variants={{
          hidden: {
            opacity: 0,
            y: 8
          },
          visible: {
            opacity: 1,
            y: 0
          }
        }} transition={{
          duration: 0.25,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-2 text-[11px] leading-snug text-[#574a63]" data-id="element-207" data-mp="3npdna4cs6nty">
              <CheckIcon size={15} strokeWidth={3} className="mt-0.5 shrink-0 text-[#b78b31]" aria-hidden="true" data-id="element-208" data-mp="30r10h06lh6sd" />
              <strong className="font-bold" data-id="element-209" data-mp="34scjgmuyqtrl">{benefit}</strong>
            </motion.li>)}
        </motion.ul>

        {/* CTA */}
        <button onClick={scrollToPurchase} className="group relative mt-5 w-full overflow-hidden rounded-full bg-[#2e1065] px-6 py-5 text-white shadow-[0_18px_34px_-14px_rgba(46,16,101,0.65)] transition-colors duration-200 ease-out hover:bg-[#3d187f] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2e1065]" data-id="element-210" data-mp="39sqrw60h85q5">
          <motion.span aria-hidden="true" animate={prefersReducedMotion ? undefined : {
          x: ['-160%', '220%']
        }} transition={{
          duration: 1.1,
          delay: 3.5,
          repeat: Infinity,
          repeatDelay: 4,
          ease: 'linear'
        }} className="absolute inset-y-0 w-1/3 -skew-x-12 bg-white/20" data-id="element-211" data-mp="1f3tzaxyw8qtw" />
          <span className="relative z-10 flex items-center justify-center gap-2.5 text-[13px] md:text-[15px] font-black uppercase tracking-[0.14em]" data-id="element-212" data-mp="1ytntfip2zi1a">
            Quiero mi sistema completo
            <ArrowRightIcon size={17} strokeWidth={2.5} className="transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-213" data-mp="27rg7ykmzalnm" />
          </span>
        </button>

        {IS_PROMOTION_ACTIVE && <p className="mt-2 text-center text-[12px] font-semibold text-[#9d412b]" data-id="element-214" data-mp="8gyc0g2949yb">
            <span aria-hidden="true" data-id="element-215" data-mp="2k30kdplium9g">🔥 </span>50% OFF por tiempo limitado
          </p>}

        <ul className="mt-3 grid grid-cols-3 gap-2 border-t border-[#e6ddcd] pt-3" data-id="element-216" data-mp="2p08v554cbo0o">
          {TRUST_FOOTER.map(item => <li key={item} className="flex flex-col items-center gap-1 text-center text-[9px] font-bold uppercase leading-tight tracking-[0.08em] text-[#65566f]" data-id="element-217" data-mp="2b82nk7f96pcu">
              <ShieldCheckIcon size={14} strokeWidth={1.8} className="text-[#a8894f]" aria-hidden="true" data-id="element-218" data-mp="21ec3rfu2n33h" />
              {item}
            </li>)}
        </ul>
      </div>
    </header>;
}